<script>
    /*
    	LandingPageFooter.svelte
    */

    import { onMount } from 'svelte';
	import { setTextAlert } from '../../stores/AlertsStore';

    // TCARE components
    import LandingPageTextButton from './LandingPageTextButton.svelte';

    const VERSION_MSG = 'v 0.12.5.2 feature/login-screens';                           // click copyright

    export let onAboutClick;
    export let onTermsClick;
    export let onPrivacyClick;

    onMount(() => {
    })

    const onCopyrightClick = () => {
        setTextAlert(VERSION_MSG, 3000);
    }



</script>

<style>
    .landing-page-footer {
        z-index: 900;
        height: 100px;
        width: 100%;
        position: fixed;
        bottom: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--tcui-primary);
    }

    .landing-page-footer .block-row {
        width: 1200px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* border: 1px solid red; */
    }

    .landing-page-footer .copyright {
        user-select: none;
        cursor: default;
        font-size: 12px;
        font-weight: 200;
        color: var(--tcare-white);
    }

    .landing-page-footer .buttons-row {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="landing-page-footer">
    <div class="block-row">
        <div class="copyright" on:click={onCopyrightClick}>
            <div>&copy; 2022 TCARE Inc. All rights reserved.</div>
        </div>
        <div class="buttons-row">
            <LandingPageTextButton onClick={onAboutClick} label={'About'} />
            <LandingPageTextButton onClick={onTermsClick} label={'Terms'} />
            <LandingPageTextButton onClick={onPrivacyClick} label={'Privacy'} />
        </div>
    </div>
</div>

